var _a;
import { __generator } from "tslib";
import { call, put, select } from 'redux-saga/effects';
import { normalize } from '../../redux/normalizr';
import { deviationSchema } from '../../redux/normalizr/schemas/deviation';
import { getCurrentUser } from '../../publicSession/selectors';
import { selectors, withOffset } from '../../Stream';
import { DeviationTypes } from '../../types/deviation';
import { fetch, fakeResponseForType } from './helpers';
import { MEDIA_POPUP_POLL_STREAM_ID, MEDIA_POPUP_STATUS_STREAM_ID, MEDIA_POPUP_JOURNAL_STREAM_ID, MEDIA_POPUP_POSTS_STREAM_ID, } from '../constants';
var streamIdToDeviationTypeMap = (_a = {},
    _a[MEDIA_POPUP_POLL_STREAM_ID] = DeviationTypes.POLL,
    _a[MEDIA_POPUP_STATUS_STREAM_ID] = DeviationTypes.STATUS,
    _a[MEDIA_POPUP_JOURNAL_STREAM_ID] = DeviationTypes.JOURNAL,
    _a[MEDIA_POPUP_POSTS_STREAM_ID] = 'all_posts',
    _a);
function handlePostStreamFetch(action) {
    var streamId, type, username, _a, offset, limit, params, fakeResponse, response, hasMore, results, normalized;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                streamId = action.streamId;
                type = streamIdToDeviationTypeMap[streamId];
                return [4 /*yield*/, select(getCurrentUser)];
            case 1:
                username = (_b.sent()).username;
                return [4 /*yield*/, select(function (state) { return ({
                        offset: withOffset.selectors.getNextOffset(state, streamId),
                        limit: selectors.getItemsPerFetch(state, streamId),
                    }); })];
            case 2:
                _a = _b.sent(), offset = _a.offset, limit = _a.limit;
                params = {
                    type: (type === 'all_posts' ? 'all' : type),
                    username: username,
                    offset: offset,
                    limit: limit,
                };
                fakeResponse = fakeResponseForType(type);
                return [4 /*yield*/, call(fetch, {
                        url: 'posts/fetch',
                        params: params,
                        fakeResponse: fakeResponse,
                    })];
            case 3:
                response = _b.sent();
                if (!!response) return [3 /*break*/, 5];
                return [4 /*yield*/, put(withOffset.actions.fetchFailure({
                        streamId: streamId,
                        errorMsg: 'Failed to fetch',
                    }))];
            case 4:
                _b.sent();
                return [2 /*return*/];
            case 5:
                hasMore = response.hasMore, results = response.results;
                if (results) {
                    normalized = normalize(results, [deviationSchema]);
                }
                return [4 /*yield*/, put(withOffset.actions.fetchSuccess({
                        streamId: streamId,
                        hasMore: results ? hasMore : false,
                        items: results ? normalized.result : [],
                        entities: results ? normalized.entities : {},
                    }))];
            case 6:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
export default handlePostStreamFetch;
//# sourceMappingURL=postStreamFetch.js.map